import {
    HTMLAttributes,
    ReactElement
} from "react";
import { Button } from "./button";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { AppConstants } from "../../core/constants";
import { InvestmentPercentage, numberWithCommas } from "../../core/utils";
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#155a9e' : '#308fe8',
    },
  }));
interface Props extends HTMLAttributes<HTMLElement> {
    item?: any;
    onClick?: any;

    contentLoading?:boolean;
}
export function BuildingProject({ item, onClick , contentLoading}: Props): ReactElement { 

    
    return (
        <div className="building-project" onClick={onClick}>
            <div className={`${contentLoading ? "bg-light-gray img-container-load" : ""}  img-container`}>
                {!contentLoading && 
                <>
                <img src={`${AppConstants.base_core_url_img}/${item?.picture}`} alt="هامرز" className="image" />
                <div className="progress-bar">
                    <div className="progress-bar-headline">
                    <span className="improvement">درصد سرمایه گذاری</span>
                    <span className="percent">{InvestmentPercentage(item).toFixed(2)} درصد</span>
                    </div>
                    <BorderLinearProgress variant="determinate" value={InvestmentPercentage(item)} />


                </div>
                </>
                }
            </div>

            <span className={item?.remain_units === 0 ? "building-project-deactive-title" : "building-project-title"}>
                
                
                
                {contentLoading ? <div className="content-loading mb-1"> </div> : <>
                    {item?.remain_units === 0 ?   " اتمام سرمایه  گذاری" : "در حال عرضه"}
                </>
                
            }
                </span>
            <span className="building-project-desc"> 
                
                {contentLoading ? <div className="content-loading"> </div> : <>
                    {item?.title}  
                </>
                
            }
                </span> 

            <div className={`${contentLoading ? "bg-light-gray" : ""}  building-project-option`}>

            {!contentLoading && 
               <>
                <span className="value">قیمت هر متر</span>
                <span className="value">{numberWithCommas(item?.unit_price)}  <span className="unit">ریال</span></span></>
            }
            </div>
            <div className={`${contentLoading ? "bg-light-gray" : ""}  building-project-option`}>
            {!contentLoading && 
               <>
            <span className="value">متراژ کل پروژه </span>
                <span className="value">{numberWithCommas(item?.units_all)}<span className="unit">{item?.unit}</span></span>
                </>
            }
            </div>
            {contentLoading ? <>
                                                        <div className="content-loading w-100"></div>
                                                    </> :




            <Button myStyle={`${item?.remain_units === 0 ? "bg-light-gray" : "bg-blue"} select-btn`} title="انتخاب" onClick={() => item?.remain_units === 0 ? {} : window.location.href = `/universal-details/${item?.id}`}/>
            }
        </div>
    )
}
export default BuildingProject;
